import { Subject, combineLatest } from 'rxjs'
import { map, switchMap } from 'rxjs/operators'
import React from 'react'
import { Link } from 'react-router-dom'
import {
  followLink$,
  createNavigateTo$,
  useStateContext,
} from '@zambezi/caballo-vivo'
import {
  isOneAccountInPath$,
  isNatWestOneAccountInPath$,
} from '@apiEnabler/ob-common/lib/url-params'

export const rootPath$ = combineLatest(
  isOneAccountInPath$,
  isNatWestOneAccountInPath$
).pipe(map(getRootPath))

export const followStoreLink$ = new Subject()

combineLatest(followStoreLink$, rootPath$).subscribe(([url, rootPath]) => {
  const targetUrl = `${rootPath}${url}`
  followLink$.next(targetUrl)
})

export const StoreLink = ({ to, children, ...rest }) => {
  const targetUrl = `${useStateContext().get('rootPath')}${to}`
  return (
    <Link {...rest} to={targetUrl}>
      {children}
    </Link>
  )
}

export const createStoreNavigateTo$ = (
  pathname,
  state,
  query,
  action,
  hash
) => {
  return rootPath$.pipe(
    switchMap(rootPath =>
      createNavigateTo$(`${rootPath}${pathname}`, state, query, action, hash)
    )
  )
}

function getRootPath([isOneAccountInPath, isNatWestOneAccountInPath]) {
  if (isOneAccountInPath) return '/oa'
  if (isNatWestOneAccountInPath) return '/noa'
  return '/ob'
}
